import { render, staticRenderFns } from "./EditorWordDetail.vue?vue&type=template&id=6a9ec3f9&scoped=true"
import script from "./EditorWordDetail.vue?vue&type=script&lang=js"
export * from "./EditorWordDetail.vue?vue&type=script&lang=js"
import style0 from "./EditorWordDetail.vue?vue&type=style&index=0&id=6a9ec3f9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a9ec3f9",
  null
  
)

export default component.exports